import { getIsMobile, MOBILE_MEDIA_QUERY } from '@utils/WindowUtils';

import { ISubmissionPayloadItem } from './types';

export type DateRangeFilter = 'ANY_TIME' | 'TODAY' | 'LAST_7' | 'LAST_30' | 'LAST_90';
export const MOBILE_VIEWPORT_MEDIA_QUERY = MOBILE_MEDIA_QUERY;

export function getInitialIsMobileViewport() {
  return getIsMobile();
}

export function isCategoriesEmpty(categories: unknown): boolean {
  if (categories == null) {
    return true;
  }
  if (Array.isArray(categories)) {
    return categories.length === 0;
  }
  if (typeof categories === 'object') {
    return Object.keys(categories).length === 0;
  }

  return true;
}

/**
 * Returns createdAfterDate and createdBeforeDate as YYYY-MM-DD for the API when a range is selected.
 * For ANY_TIME returns no dates (no date restriction). Uses UTC. createdBeforeDate is the day
 * after the end of the range so that createdAt <= start of that day includes the full end date.
 */
export function getDateRangeForFilter(preset: DateRangeFilter): {
  createdAfterDate?: string;
  createdBeforeDate?: string;
} {
  if (preset === 'ANY_TIME') {
    return {};
  }
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const d = now.getUTCDate();
  const pad = (n: number) => String(n).padStart(2, '0');
  const toDateStr = (date: Date) => `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
  const tomorrow = new Date(Date.UTC(y, m, d + 1));
  const createdBeforeDate = toDateStr(tomorrow);
  if (preset === 'TODAY') {
    const startOfToday = `${y}-${pad(m + 1)}-${pad(d)}`;

    return { createdAfterDate: startOfToday, createdBeforeDate };
  }
  const daysAgo = preset === 'LAST_7' ? 7 : preset === 'LAST_30' ? 30 : 90;
  const startDate = new Date(Date.UTC(y, m, d - daysAgo));

  return { createdAfterDate: toDateStr(startDate), createdBeforeDate };
}

export const toCardProps = (submission: ISubmissionPayloadItem) => ({
  category: submission.category.name,
  imageUrls: submission.attachments.filter((a) => a.mimeType.startsWith('image/')).map((a) => a.fileURL),
  description: submission.description,
  status: submission.status.toLowerCase() as 'open' | 'closed',
  date: submission.createdAt,
  followerCount: submission.followerCount,
  isFollowing: submission.isFollowing ?? null,
  isSubmitter: submission.isSubmitter ?? null,
});
